export default {
  inDevelopment: {
    summary: 'Der Produktionsplaner ist in Entwicklung',
    details: 'Hier planen Sie künftig anhand Ihrer Aufträge, welche Chargen wann auf welchem Ofen laufen.',
  },
};
